import { Dialog, Stack, Typography , Button } from '@mui/material';
import { Spin } from 'antd';
// import { Button } from 'antd';
import React from 'react';
import { AppColors } from '../Utils/helper/AppColors';

export default function DeleteConfirm({ open, onClose, onDelete, loading, title, subTitle , extra, zIndex = 1500 }) {
	
	return (
		<Dialog open={open} onClose={onClose}  sx={{ zIndex: zIndex }}	>
			<Stack p={2} minWidth={400}>
				<Typography variant="body1">{title}</Typography>
				<Typography variant="subtitle2" >{subTitle}</Typography>
				<Typography variant="subtitle2" component="div" dangerouslySetInnerHTML={{ __html: extra }} />
				<Stack mt={3} direction="row" gap={2} justifyContent="flex-end">
					{/* <Button size="middle" onClick={onClose} type="default">
						Cancel
					</Button>
					<Button size="middle" loading={loading} onClick={onDelete} type="primary">
						Confirm
					</Button> */}
					  <Button
                        size="medium"
						color='info'
						variant='outlined'
                        onClick={onClose}
                        disabled={loading}
                    >
                        Cancel
                    </Button>
                    <Button
                        size="medium"
						color='info'
						variant='contained'
                        onClick={onDelete}
                        disabled={loading}
                    >
                        {loading ? <Spin /> : 'Confirm'}
                    </Button>
				</Stack>
			</Stack>
		</Dialog>
	);
}
